import { faEnvelope, faInboxIn } from '@fortawesome/pro-solid-svg-icons'
import { useMemo, useState } from 'react'
import type { SendEmailEvent } from '~/domains/actions/types'
import { MessageStatusIcon } from '~/domains/messaging/components/MessageStatusIcon'
import { EMAIL_STATUS_CONFIG } from '~/domains/messaging/types'
import { sanitizeEmailHtml } from '~/utils/sanitize'
import {
  historyItemAutoReplyToggle,
  historyItemEmailStatusIcon
} from '../ApplicantHistory.css'
import { BaseHistoryCard } from './BaseHistoryCard'
import { HistoryItemContent } from './HistoryItemContent'

export const EmailHistoryCard = ({ event }: { event: SendEmailEvent }) => {
  const [isAutoReplyContentVisible, setIsAutoReplyContentVisible] =
    useState(false)
  const statusConfig = event.emailStatus
    ? (EMAIL_STATUS_CONFIG[event.emailStatus] ?? null)
    : null
  const isAutoReply = event.type === 'email_received' && event.isAutoReply
  const sanitizedExcerpt = useMemo(
    () => (event.excerpt ? sanitizeEmailHtml(event.excerpt) : null),
    [event.excerpt]
  )

  return (
    <BaseHistoryCard
      event={event}
      icon={event.type === 'email_received' ? faInboxIn : faEnvelope}
      title={
        isAutoReply
          ? 'Email reçu (réponse auto)'
          : (event.subject ??
            (event.type === 'email_received' ? 'Email reçu' : 'Email envoyé'))
      }
    >
      {event.notes && (
        <HistoryItemContent>Notes : {event.notes}</HistoryItemContent>
      )}
      {sanitizedExcerpt && (!isAutoReply || isAutoReplyContentVisible) && (
        <HistoryItemContent
          // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized by DOMPurify
          dangerouslySetInnerHTML={{ __html: sanitizedExcerpt }}
        />
      )}
      {event.excerpt && isAutoReply && (
        <button
          type="button"
          className={historyItemAutoReplyToggle}
          onClick={() => setIsAutoReplyContentVisible((visible) => !visible)}
        >
          {isAutoReplyContentVisible ? 'Masquer' : 'Voir'} le contenu
        </button>
      )}
      <MessageStatusIcon
        statusConfig={statusConfig}
        className={historyItemEmailStatusIcon}
      />
    </BaseHistoryCard>
  )
}
